module.exports = __webpack_public_path__ + "media/images/athletes/2186-edc9c01f5a687d520d0b25f78b8e9f94.png";